
/**
 * Initializes audio controls for inclusive panel.
 * Accepts isMobile boolean (true for mobile layout).
 * Returns cleanup() function that removes listeners.
 */
export function inclusiveAudio(isMobileScreen) {
  var suffix = isMobileScreen ? "-mob" : "";
  var audio = document.getElementById("audio" + suffix);
  var playPauseBtn = document.getElementById("play-pause" + suffix);
  var playIcon = document.getElementById("icon-play" + suffix);
  var pauseIcon = document.getElementById("icon-pause" + suffix);
  var currentTimeDisplay = document.getElementById("current-time" + suffix);
  var progressContainer = document.getElementById("progress-container" + suffix);
  var progressBar = document.getElementById("progress-bar" + suffix);
  var volumeContainer = document.getElementById("volume-container" + suffix);
  var volumeBar = document.getElementById("volume-bar" + suffix);
  var volumeText = document.getElementById("volume-text" + suffix);

  var listeners = [];

  function on(el, ev, handler, options) {
    if (!el) return;
    el.addEventListener(ev, handler, options || false);
    listeners.push({ el: el, ev: ev, handler: handler, options: options });
  }
  function offAll() {
    for (var i = 0; i < listeners.length; i++) {
      try {
        var it = listeners[i];
        it.el.removeEventListener(it.ev, it.handler, it.options || false);
      } catch (e) {}
    }
    listeners = [];
  }

  if (!audio) return function cleanupEmpty() { offAll(); };

  // helpers
  function formatTime(time) {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time % 60).toString().padStart(2, "0");
    return minutes + ":" + seconds;
  }

  // play/pause toggle
  on(playPauseBtn, "click", function (e) {
    if (audio.paused) audio.play();
    else audio.pause();
  });

  on(audio, "play", function () {
    if (playIcon) playIcon.style.display = "none";
    if (pauseIcon) pauseIcon.style.display = "inline";
  });
  on(audio, "pause", function () {
    if (playIcon) playIcon.style.display = "inline";
    if (pauseIcon) pauseIcon.style.display = "none";
  });

  // timeupdate
  on(audio, "timeupdate", function () {
    var currentTime = audio.currentTime || 0;
    var duration = audio.duration || 0;
    var percent = duration ? (currentTime / duration) * 100 : 0;
    if (progressBar) progressBar.style.width = percent + "%";
    if (currentTimeDisplay) currentTimeDisplay.textContent = formatTime(currentTime);
  });

  // click to seek
  on(progressContainer, "click", function (e) {
    if (!audio || !progressContainer) return;
    var rect = progressContainer.getBoundingClientRect();
    var clickX = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
    var width = rect.width || 1;
    var duration = audio.duration || 0;
    if (duration > 0) audio.currentTime = (clickX / width) * duration;
  });

  // volume click
  on(volumeContainer, "click", function (e) {
    if (!audio || !volumeContainer) return;
    var rect = volumeContainer.getBoundingClientRect();
    var clickX = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
    var width = rect.width || 1;
    var v = Math.max(0, Math.min(1, clickX / width));
    audio.volume = v;
    if (volumeBar) volumeBar.style.width = Math.round(v * 100) + "%";
    if (volumeText) volumeText.textContent = Math.round(v * 100) + "%";
  });

  // basic drag support for progress and volume (mouse)
  var dragging = null;
  function docMove(e) {
    if (!dragging) return;
    if (dragging.type === "progress" && progressContainer && audio) {
      var rect = progressContainer.getBoundingClientRect();
      var clientX = e.clientX || (e.touches && e.touches[0].clientX);
      var x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      var percent = x / rect.width;
      if (progressBar) progressBar.style.width = percent * 100 + "%";
      if (!isNaN(audio.duration) && audio.duration > 0) audio.currentTime = percent * audio.duration;
    }
    if (dragging.type === "volume" && volumeContainer && audio) {
      var rectV = volumeContainer.getBoundingClientRect();
      var clientXV = e.clientX || (e.touches && e.touches[0].clientX);
      var xV = Math.max(0, Math.min(clientXV - rectV.left, rectV.width));
      var p = xV / rectV.width;
      if (volumeBar) volumeBar.style.width = Math.round(p * 100) + "%";
      audio.volume = p;
      if (volumeText) volumeText.textContent = Math.round(p * 100) + "%";
    }
  }
  function docUp() {
    dragging = null;
    document.removeEventListener("mousemove", docMove);
    document.removeEventListener("mouseup", docUp);
    document.removeEventListener("touchmove", docMove);
    document.removeEventListener("touchend", docUp);
  }
  function startDragProgress(e) {
    dragging = { type: "progress" };
    docMove(e);
    document.addEventListener("mousemove", docMove);
    document.addEventListener("mouseup", docUp);
    document.addEventListener("touchmove", docMove, { passive: false });
    document.addEventListener("touchend", docUp);
  }
  function startDragVolume(e) {
    dragging = { type: "volume" };
    docMove(e);
    document.addEventListener("mousemove", docMove);
    document.addEventListener("mouseup", docUp);
    document.addEventListener("touchmove", docMove, { passive: false });
    document.addEventListener("touchend", docUp);
  }

  if (progressContainer) {
    progressContainer.addEventListener("mousedown", startDragProgress);
    progressContainer.addEventListener("touchstart", startDragProgress, { passive: false });
    listeners.push({ el: progressContainer, ev: "mousedown", handler: startDragProgress });
    listeners.push({ el: progressContainer, ev: "touchstart", handler: startDragProgress });
  }
  if (volumeContainer) {
    volumeContainer.addEventListener("mousedown", startDragVolume);
    volumeContainer.addEventListener("touchstart", startDragVolume, { passive: false });
    listeners.push({ el: volumeContainer, ev: "mousedown", handler: startDragVolume });
    listeners.push({ el: volumeContainer, ev: "touchstart", handler: startDragVolume });
  }

  // initial UI (volume)
  try {
    var initialVolume = audio.volume || 0.7;
    audio.volume = initialVolume;
    if (volumeBar) volumeBar.style.width = Math.round(initialVolume * 100) + "%";
    if (volumeText) volumeText.textContent = Math.round(initialVolume * 100) + "%";
  } catch (e) {}

  // cleanup
  function cleanup() {
    offAll();
    try {
      document.removeEventListener("mousemove", docMove);
      document.removeEventListener("mouseup", docUp);
      document.removeEventListener("touchmove", docMove);
      document.removeEventListener("touchend", docUp);
    } catch (e) {}
  }

  return cleanup;
}



// WEBPACK FOOTER //
// src/components/inclusive/utils/inclusiveAudio.js